export default __webpack_public_path__ + "static/media/subpics2.e83fa375.jpg";